import _slicedToArray from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var C = function C(t) {
    var s, c, n, i, l;
    var e = {
      formattedAddress: t.formatted_address,
      lat: (c = (s = t.geometry) == null ? void 0 : s.location) == null ? void 0 : c.lat(),
      lng: (i = (n = t.geometry) == null ? void 0 : n.location) == null ? void 0 : i.lng(),
      country: "US"
    };
    return (l = t.address_components) == null || l.forEach(function (r) {
      r.types.includes("street_number") ? e.streetNumber = r.long_name : r.types.includes("route") ? (e.routeLong = r.long_name, e.routeShort = r.short_name) : r.types.includes("postal_code") ? e.zipCode = r.long_name : r.types.includes("neighborhood") ? e.neighborhood = r.long_name : r.types.includes("administrative_area_level_1") ? e.state = r.short_name : r.types.includes("locality") ? e.city = r.long_name : r.types.includes("subpremise") ? e.unitNumber = r.long_name : r.types.includes("administrative_area_level_2") ? e.city || (e.city = r.long_name) : r.types.includes("country") && (e.country = r.short_name);
    }), e.state ? e : null;
  },
  u = function u(t) {
    return encodeURIComponent(String(t).replace(/-/gm, "_").replace(/ /gm, "-").toLowerCase());
  },
  y = function y(t) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : " ";
    return t.split(e).map(function (s) {
      return s.charAt(0).toUpperCase() + s.slice(1);
    }).join(e);
  },
  I = function I(t) {
    return y(y(decodeURIComponent(String(t).replace(/-/gm, " ").replace(/_/gm, "-"))), "-");
  },
  w = function w(_ref) {
    var t = _ref.city,
      e = _ref.state,
      _ref$listings = _ref.listings,
      s = _ref$listings === void 0 ? "Investment" : _ref$listings,
      c = _ref.neighborhood,
      n = _ref.zipCode,
      i = _ref.country,
      l = _ref.propertyType;
    var a = "/explore/search/".concat({
      Investment: "investment",
      Airbnb: "short-term",
      Traditional: "rentals"
    }[s]);
    return i && (a = a + "/".concat(u(i))), e && (a = a + "/".concat(u(e))), t && (a = a + "/".concat(u(t))), n && (a = a + "/".concat(u(n))), !n && c && (a = a + "/".concat(u(c))), l && (a = a + "/".concat(u(l))), "".concat(a, "/overview");
  },
  N = function N(t, e) {
    var s = C(t);
    return s ? L(s, e) : null;
  },
  L = function L(t, e) {
    var _ref2 = e || {},
      _ref2$extraHashParams = _ref2.extraHashParams,
      s = _ref2$extraHashParams === void 0 ? {} : _ref2$extraHashParams,
      c = _objectSpread(_objectSpread({}, (e == null ? void 0 : e.extraSearchParams) || {}), {}, {
        page: e != null && e.page && e.page > 1 ? e.page : null
        // drop default page value = 1
      });
    if (t) {
      var n = t.city,
        i = t.state,
        l = t.neighborhood,
        r = t.zipCode,
        a = t.country,
        p = t.lat,
        S = t.lng,
        b = t.formattedAddress,
        U = t.streetNumber,
        P = t.unitNumber,
        $ = t.routeLong,
        v = t.routeShort,
        x = {
          lat: p,
          lng: S,
          formattedAddress: b,
          streetNumber: U,
          unitNumber: P,
          routeLong: $,
          routeShort: v
        };
      var d = w({
        city: n,
        state: i,
        neighborhood: l,
        zipCode: r,
        country: a,
        listings: e == null ? void 0 : e.listings,
        propertyType: e == null ? void 0 : e.propertyType
      });
      var h = new URLSearchParams();
      Object.entries(_objectSpread(_objectSpread({}, s), x)).forEach(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          g = _ref4[0],
          o = _ref4[1];
        o != null && h.append(g, String(o));
      });
      var f = new URLSearchParams();
      Object.entries(c).forEach(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
          g = _ref6[0],
          o = _ref6[1];
        o != null && f.append(g, String(o));
      });
      var m = f.toString();
      m && (d = d + "?" + m);
      var _ = h.toString();
      return _ && (d = d + "#" + _), d;
    }
    return null;
  };
export { I as decodeComponent, u as encodeComponent, L as getPlaceSearchUrl, N as getSearchUrlFromGooglePlace, C as parseGooglePlace };